<template>
  <v-progress-circular
    class="mt-1 white--text"
    :rotate="270"
    :size="170"
    :width="15"
    :value="available_percentage"
    :color="available_percentage == 0 ? 'red' : 'green'"
  >
    {{available_percentage }}
    {{$t('rms_filter_result_availability_percentage_label') }}
  </v-progress-circular>
</template>

<script>
export default {
  data() {
    return {
      available_percentage: null
    };
  },
  created() {
    let percentage = this.film.available_percentage;
    this.available_percentage =
      percentage % 1 != 0 // That means the number is a decimal number.
        ? percentage.toFixed(2)
        : percentage;
  },
  props: ["film"]
};
</script>

<style>
</style>

